var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.role === 'screen')?_c('div',{staticClass:"full"},[_c('AudioStart',{attrs:{"audio":"/2022/audio/start-missie-1.mp3"}}),_c('Missie',{attrs:{"text":"Missie 1"}})],1):_c('NextSceneButton',{attrs:{"role":_vm.role}})}
var staticRenderFns = []

export { render, staticRenderFns }